import { AddressDetail, Organization } from 'shared/Redux/interfaces';

export default function formatDefaultAddressDetail(
  organization: Organization,
  addressDetail: AddressDetail,
  withComma: boolean = false
): string {
  if (organization?.setting_simple_addresses) {
    return addressDetail?.display_short_simple;
  }

  if (withComma) {
    return addressDetail?.display_short_with_comma;
  }

  return addressDetail?.display_short;
}
